module.exports = __webpack_public_path__ + "prod/1.42.2/img/baiguoyuan-icon.fe79c7fb.png";